import { useQuery } from '@apollo/client'
import { CLIENT } from '../graphql'

/**
 * @param {string} clientName
 */
export default function useClientByName(clientName) {
  const { data, loading, error } = useQuery(CLIENT, {
    variables: { clientName },
  })

  return { client: data?.clientByName, loading, error }
}
